import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAPI, postAPI, putAPI } from "../../service/http-service";
import { RoleAccessAPI } from "./RoleAccessAPIs";

export interface Role {
  id?: string | number;
  roleName: string;
  roleDescription: string;
  lastUpdatedBy: string;
  displayInFranchisee: boolean;
  active: boolean;
}

export interface RoleState {
  loading: boolean;
  error: string | undefined;
  roleResponse: RoleResponse | undefined;
}

export interface RoleResponse {
  errors: [string] | undefined;
  message: string | undefined;
  data: Role[];
}

let initialState: RoleState = {
  loading: false,
  error: undefined,
  roleResponse: undefined,
};

export const roleAction = createAsyncThunk("master/role", async (role: any) => {
  try {
    let response;
    switch (role.apiAction) {
      case "list":
        response = await getAPI(RoleAccessAPI.list);
        break;
      case "create":
        response = await postAPI(RoleAccessAPI.create, role.reqParams);
        break;
      case "update":
        response = await putAPI(RoleAccessAPI.edit, role.reqParams);
        break;
      case "list-role-access":
        response = await getAPI(`${RoleAccessAPI.list}/${role.id}/accesses`);
        break;
      case "update-role-access":
        response = await postAPI(
          `${RoleAccessAPI.edit}/${role.id}/accesses`,
          role.roleAccess
        );
        break;
    }
    return response;
  } catch (err) {
    // This is kept for future reference
    // return custom error message from backend if present
    // if (error.response && error.response.data.message) {
    //   return rejectWithValue(error.response.data.message)
    // } else {
    //   return rejectWithValue(error.message)
    // }
    return err;
  }
});

const roleAccessSlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(roleAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(roleAction.fulfilled, (state, { payload }: any) => {
      state.loading = false;
      state.roleResponse = payload.data as RoleResponse;
    });
    builder.addCase(roleAction.rejected, (state, { payload }: any) => {
      state.loading = false;
      // This is kept purposefully to check the data coming while error
      if (payload) {
        state.roleResponse = payload.data.data as RoleResponse;
      } else {
        state.error = payload.error.message;
      }
    });
  },
});

const roleAccessReducer = roleAccessSlice.reducer;
export default roleAccessReducer;
